module.exports = __webpack_public_path__ + "img/spicy-pasta.725af4ba.jpg";